import React, { FunctionComponent } from 'react';
import Link, { ILinkProps } from 'app/components/router/Link';
import BaseButton from 'app/components/common/BaseButton';
import { useCss } from 'app/utils/css';
import { useHoverState } from '@engoo/react-hover-state';
import { getNavLinkStyles } from 'app/components/presentation/nav/styles';

interface INavLinkProps extends ILinkProps {
  // Classname is specified by NavLink, so ensure it is not propagated.
  className?: never;
  logo?: boolean;
  selected?: boolean;
}

const NavLink: FunctionComponent<INavLinkProps> = ({ selected = false, logo = false, ...props }) => {
  const [hovered, hoverRef] = useHoverState();
  const css = useCss();
  const className = css('navLink', getNavLinkStyles({ active: false, selected, hovered, logo }));
  return (<Link className={className} getRef={hoverRef} {...props} />);
};

interface INavButtonProps {
  active?: boolean;
  onClick: () => void;
  selected?: boolean;
}

export const NavButton: FunctionComponent<INavButtonProps> = ({
  children,
  onClick,
  active = false,
  selected = false,
}) => {
  const [hovered, hoverRef] = useHoverState();
  const css = useCss();
  const className = css('navButton', getNavLinkStyles({ active, selected, hovered, logo: false }));

  return (
    <BaseButton type="button" className={className} onClick={onClick} getRef={hoverRef}>
      {children}
    </BaseButton>
  );
};

export default NavLink;
